module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud.b678363c0a1907ba30b177ea1505aaca.png";